/* tslint:disable */
/* eslint-disable */
/**
 * CipherMail back-end API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { MailDetails } from '../model';
// @ts-ignore
import type { MailDetailsWithMIME } from '../model';
/**
 * MPAMailRepositoryApi - axios parameter creator
 * @export
 */
export const MPAMailRepositoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} mailRepositoryUrl 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailRepositoryControllerDeleteAllMail: async (mailRepositoryUrl: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mailRepositoryUrl' is not null or undefined
            assertParamExists('mailRepositoryControllerDeleteAllMail', 'mailRepositoryUrl', mailRepositoryUrl)
            const localVarPath = `/api/mpa/mailrepository/deleteAllMail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (mailRepositoryUrl !== undefined) {
                localVarQueryParameter['mailRepositoryUrl'] = mailRepositoryUrl;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} mailRepositoryUrl 
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailRepositoryControllerDeleteMail: async (mailRepositoryUrl: string, key: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mailRepositoryUrl' is not null or undefined
            assertParamExists('mailRepositoryControllerDeleteMail', 'mailRepositoryUrl', mailRepositoryUrl)
            // verify required parameter 'key' is not null or undefined
            assertParamExists('mailRepositoryControllerDeleteMail', 'key', key)
            const localVarPath = `/api/mpa/mailrepository/deleteMail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (mailRepositoryUrl !== undefined) {
                localVarQueryParameter['mailRepositoryUrl'] = mailRepositoryUrl;
            }

            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} mailRepositoryUrl 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailRepositoryControllerDeleteMails: async (mailRepositoryUrl: string, requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mailRepositoryUrl' is not null or undefined
            assertParamExists('mailRepositoryControllerDeleteMails', 'mailRepositoryUrl', mailRepositoryUrl)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('mailRepositoryControllerDeleteMails', 'requestBody', requestBody)
            const localVarPath = `/api/mpa/mailrepository/deleteMails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (mailRepositoryUrl !== undefined) {
                localVarQueryParameter['mailRepositoryUrl'] = mailRepositoryUrl;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} mailRepositoryUrl 
         * @param {string} key 
         * @param {boolean} [includeMIME] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailRepositoryControllerGetMail: async (mailRepositoryUrl: string, key: string, includeMIME?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mailRepositoryUrl' is not null or undefined
            assertParamExists('mailRepositoryControllerGetMail', 'mailRepositoryUrl', mailRepositoryUrl)
            // verify required parameter 'key' is not null or undefined
            assertParamExists('mailRepositoryControllerGetMail', 'key', key)
            const localVarPath = `/api/mpa/mailrepository/getMail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (mailRepositoryUrl !== undefined) {
                localVarQueryParameter['mailRepositoryUrl'] = mailRepositoryUrl;
            }

            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }

            if (includeMIME !== undefined) {
                localVarQueryParameter['includeMIME'] = includeMIME;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} mailRepositoryUrl 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailRepositoryControllerGetMailKeys: async (mailRepositoryUrl: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mailRepositoryUrl' is not null or undefined
            assertParamExists('mailRepositoryControllerGetMailKeys', 'mailRepositoryUrl', mailRepositoryUrl)
            const localVarPath = `/api/mpa/mailrepository/getMailKeys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (mailRepositoryUrl !== undefined) {
                localVarQueryParameter['mailRepositoryUrl'] = mailRepositoryUrl;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} mailRepositoryUrl 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailRepositoryControllerGetMailRepositorySize: async (mailRepositoryUrl: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mailRepositoryUrl' is not null or undefined
            assertParamExists('mailRepositoryControllerGetMailRepositorySize', 'mailRepositoryUrl', mailRepositoryUrl)
            const localVarPath = `/api/mpa/mailrepository/getRepositorySize`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (mailRepositoryUrl !== undefined) {
                localVarQueryParameter['mailRepositoryUrl'] = mailRepositoryUrl;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailRepositoryControllerGetMailRepositoryUrls: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/mpa/mailrepository/getMailRepositoryUrls`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} mailRepositoryUrl 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailRepositoryControllerGetMails: async (mailRepositoryUrl: string, requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mailRepositoryUrl' is not null or undefined
            assertParamExists('mailRepositoryControllerGetMails', 'mailRepositoryUrl', mailRepositoryUrl)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('mailRepositoryControllerGetMails', 'requestBody', requestBody)
            const localVarPath = `/api/mpa/mailrepository/getMails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (mailRepositoryUrl !== undefined) {
                localVarQueryParameter['mailRepositoryUrl'] = mailRepositoryUrl;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} mailRepositoryUrl 
         * @param {Array<string>} requestBody 
         * @param {string} [newState] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailRepositoryControllerRequeueMails: async (mailRepositoryUrl: string, requestBody: Array<string>, newState?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mailRepositoryUrl' is not null or undefined
            assertParamExists('mailRepositoryControllerRequeueMails', 'mailRepositoryUrl', mailRepositoryUrl)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('mailRepositoryControllerRequeueMails', 'requestBody', requestBody)
            const localVarPath = `/api/mpa/mailrepository/requeueMails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (mailRepositoryUrl !== undefined) {
                localVarQueryParameter['mailRepositoryUrl'] = mailRepositoryUrl;
            }

            if (newState !== undefined) {
                localVarQueryParameter['newState'] = newState;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MPAMailRepositoryApi - functional programming interface
 * @export
 */
export const MPAMailRepositoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MPAMailRepositoryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} mailRepositoryUrl 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mailRepositoryControllerDeleteAllMail(mailRepositoryUrl: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mailRepositoryControllerDeleteAllMail(mailRepositoryUrl, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MPAMailRepositoryApi.mailRepositoryControllerDeleteAllMail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} mailRepositoryUrl 
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mailRepositoryControllerDeleteMail(mailRepositoryUrl: string, key: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mailRepositoryControllerDeleteMail(mailRepositoryUrl, key, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MPAMailRepositoryApi.mailRepositoryControllerDeleteMail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} mailRepositoryUrl 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mailRepositoryControllerDeleteMails(mailRepositoryUrl: string, requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mailRepositoryControllerDeleteMails(mailRepositoryUrl, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MPAMailRepositoryApi.mailRepositoryControllerDeleteMails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} mailRepositoryUrl 
         * @param {string} key 
         * @param {boolean} [includeMIME] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mailRepositoryControllerGetMail(mailRepositoryUrl: string, key: string, includeMIME?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MailDetailsWithMIME>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mailRepositoryControllerGetMail(mailRepositoryUrl, key, includeMIME, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MPAMailRepositoryApi.mailRepositoryControllerGetMail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} mailRepositoryUrl 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mailRepositoryControllerGetMailKeys(mailRepositoryUrl: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mailRepositoryControllerGetMailKeys(mailRepositoryUrl, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MPAMailRepositoryApi.mailRepositoryControllerGetMailKeys']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} mailRepositoryUrl 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mailRepositoryControllerGetMailRepositorySize(mailRepositoryUrl: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mailRepositoryControllerGetMailRepositorySize(mailRepositoryUrl, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MPAMailRepositoryApi.mailRepositoryControllerGetMailRepositorySize']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mailRepositoryControllerGetMailRepositoryUrls(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mailRepositoryControllerGetMailRepositoryUrls(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MPAMailRepositoryApi.mailRepositoryControllerGetMailRepositoryUrls']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} mailRepositoryUrl 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mailRepositoryControllerGetMails(mailRepositoryUrl: string, requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MailDetails>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mailRepositoryControllerGetMails(mailRepositoryUrl, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MPAMailRepositoryApi.mailRepositoryControllerGetMails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} mailRepositoryUrl 
         * @param {Array<string>} requestBody 
         * @param {string} [newState] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mailRepositoryControllerRequeueMails(mailRepositoryUrl: string, requestBody: Array<string>, newState?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mailRepositoryControllerRequeueMails(mailRepositoryUrl, requestBody, newState, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MPAMailRepositoryApi.mailRepositoryControllerRequeueMails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MPAMailRepositoryApi - factory interface
 * @export
 */
export const MPAMailRepositoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MPAMailRepositoryApiFp(configuration)
    return {
        /**
         * 
         * @param {string} mailRepositoryUrl 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailRepositoryControllerDeleteAllMail(mailRepositoryUrl: string, options?: any): AxiosPromise<void> {
            return localVarFp.mailRepositoryControllerDeleteAllMail(mailRepositoryUrl, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} mailRepositoryUrl 
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailRepositoryControllerDeleteMail(mailRepositoryUrl: string, key: string, options?: any): AxiosPromise<void> {
            return localVarFp.mailRepositoryControllerDeleteMail(mailRepositoryUrl, key, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} mailRepositoryUrl 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailRepositoryControllerDeleteMails(mailRepositoryUrl: string, requestBody: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.mailRepositoryControllerDeleteMails(mailRepositoryUrl, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} mailRepositoryUrl 
         * @param {string} key 
         * @param {boolean} [includeMIME] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailRepositoryControllerGetMail(mailRepositoryUrl: string, key: string, includeMIME?: boolean, options?: any): AxiosPromise<MailDetailsWithMIME> {
            return localVarFp.mailRepositoryControllerGetMail(mailRepositoryUrl, key, includeMIME, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} mailRepositoryUrl 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailRepositoryControllerGetMailKeys(mailRepositoryUrl: string, options?: any): AxiosPromise<Array<string>> {
            return localVarFp.mailRepositoryControllerGetMailKeys(mailRepositoryUrl, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} mailRepositoryUrl 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailRepositoryControllerGetMailRepositorySize(mailRepositoryUrl: string, options?: any): AxiosPromise<number> {
            return localVarFp.mailRepositoryControllerGetMailRepositorySize(mailRepositoryUrl, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailRepositoryControllerGetMailRepositoryUrls(options?: any): AxiosPromise<Array<string>> {
            return localVarFp.mailRepositoryControllerGetMailRepositoryUrls(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} mailRepositoryUrl 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailRepositoryControllerGetMails(mailRepositoryUrl: string, requestBody: Array<string>, options?: any): AxiosPromise<Array<MailDetails>> {
            return localVarFp.mailRepositoryControllerGetMails(mailRepositoryUrl, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} mailRepositoryUrl 
         * @param {Array<string>} requestBody 
         * @param {string} [newState] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mailRepositoryControllerRequeueMails(mailRepositoryUrl: string, requestBody: Array<string>, newState?: string, options?: any): AxiosPromise<void> {
            return localVarFp.mailRepositoryControllerRequeueMails(mailRepositoryUrl, requestBody, newState, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MPAMailRepositoryApi - object-oriented interface
 * @export
 * @class MPAMailRepositoryApi
 * @extends {BaseAPI}
 */
export class MPAMailRepositoryApi extends BaseAPI {
    /**
     * 
     * @param {string} mailRepositoryUrl 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MPAMailRepositoryApi
     */
    public mailRepositoryControllerDeleteAllMail(mailRepositoryUrl: string, options?: RawAxiosRequestConfig) {
        return MPAMailRepositoryApiFp(this.configuration).mailRepositoryControllerDeleteAllMail(mailRepositoryUrl, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} mailRepositoryUrl 
     * @param {string} key 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MPAMailRepositoryApi
     */
    public mailRepositoryControllerDeleteMail(mailRepositoryUrl: string, key: string, options?: RawAxiosRequestConfig) {
        return MPAMailRepositoryApiFp(this.configuration).mailRepositoryControllerDeleteMail(mailRepositoryUrl, key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} mailRepositoryUrl 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MPAMailRepositoryApi
     */
    public mailRepositoryControllerDeleteMails(mailRepositoryUrl: string, requestBody: Array<string>, options?: RawAxiosRequestConfig) {
        return MPAMailRepositoryApiFp(this.configuration).mailRepositoryControllerDeleteMails(mailRepositoryUrl, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} mailRepositoryUrl 
     * @param {string} key 
     * @param {boolean} [includeMIME] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MPAMailRepositoryApi
     */
    public mailRepositoryControllerGetMail(mailRepositoryUrl: string, key: string, includeMIME?: boolean, options?: RawAxiosRequestConfig) {
        return MPAMailRepositoryApiFp(this.configuration).mailRepositoryControllerGetMail(mailRepositoryUrl, key, includeMIME, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} mailRepositoryUrl 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MPAMailRepositoryApi
     */
    public mailRepositoryControllerGetMailKeys(mailRepositoryUrl: string, options?: RawAxiosRequestConfig) {
        return MPAMailRepositoryApiFp(this.configuration).mailRepositoryControllerGetMailKeys(mailRepositoryUrl, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} mailRepositoryUrl 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MPAMailRepositoryApi
     */
    public mailRepositoryControllerGetMailRepositorySize(mailRepositoryUrl: string, options?: RawAxiosRequestConfig) {
        return MPAMailRepositoryApiFp(this.configuration).mailRepositoryControllerGetMailRepositorySize(mailRepositoryUrl, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MPAMailRepositoryApi
     */
    public mailRepositoryControllerGetMailRepositoryUrls(options?: RawAxiosRequestConfig) {
        return MPAMailRepositoryApiFp(this.configuration).mailRepositoryControllerGetMailRepositoryUrls(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} mailRepositoryUrl 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MPAMailRepositoryApi
     */
    public mailRepositoryControllerGetMails(mailRepositoryUrl: string, requestBody: Array<string>, options?: RawAxiosRequestConfig) {
        return MPAMailRepositoryApiFp(this.configuration).mailRepositoryControllerGetMails(mailRepositoryUrl, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} mailRepositoryUrl 
     * @param {Array<string>} requestBody 
     * @param {string} [newState] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MPAMailRepositoryApi
     */
    public mailRepositoryControllerRequeueMails(mailRepositoryUrl: string, requestBody: Array<string>, newState?: string, options?: RawAxiosRequestConfig) {
        return MPAMailRepositoryApiFp(this.configuration).mailRepositoryControllerRequeueMails(mailRepositoryUrl, requestBody, newState, options).then((request) => request(this.axios, this.basePath));
    }
}

